import { render, staticRenderFns } from "./DialogCreatingBroker.vue?vue&type=template&id=08d15ba4&scoped=true"
import script from "./DialogCreatingBroker.vue?vue&type=script&lang=js"
export * from "./DialogCreatingBroker.vue?vue&type=script&lang=js"
import style0 from "./DialogCreatingBroker.vue?vue&type=style&index=0&id=08d15ba4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d15ba4",
  null
  
)

export default component.exports